export default __webpack_public_path__ + "static/media/logo.8c81d3e1.png";